import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import React from "react";

interface OverlayProps {
  overlayStyle: OverlayStyle;
}

export enum OverlayStyle {
  UNAVAILABLE,
  DARKENING,
  NONE,
}

export const Overlay: React.FC<OverlayProps> = ({ overlayStyle }) => {
  switch (overlayStyle) {
    case OverlayStyle.UNAVAILABLE:
      return (
        <div className="bg-core-surface-inverse/50 rounded-fs-component-default absolute top-0 left-0 flex h-full w-full items-center justify-center" />
      );
    case OverlayStyle.DARKENING:
      return <TransparencyOverlay />;
    default:
      return null;
  }
};
